import { Injectable } from '@angular/core';
import { DialogTableDataRow } from '../../interfaces/dialog-table-data-row';
import { PaymentData } from '../../interfaces/payment/payment-data';

@Injectable({
  providedIn: 'root'
})
export class ShopIntegrationToTableDataMapper {

  constructor() { }

  /**
   * Map table data
   * @param paymentMethodData
   * @param tenantId
   */
  public map(paymentMethodData: PaymentData, tenantId: string): DialogTableDataRow[] {
    return [
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'MERCHANTID',
        value: tenantId
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PAYMENTMETHODID',
        value: paymentMethodData.projectId,
      },
      {
        titleStyleClass: 'font-bold',
        i18nTitleKey: 'PASSWORD',
        value: paymentMethodData.password,
        valueType: 'PASSWORD'
      }
    ]
  }

}
